module.exports = __webpack_public_path__ + "img/16581260_L.6250fb7a.png";